import React from 'react';

import styles from './AccountFeatures.module.scss';

import allDayAccess from '../../public/images/24-7-access.svg';
import instantSharing from '../../public/images/instant-sharing.svg';
import keepPlanning from '../../public/images/keep-planning.svg';

const {
  'account-features': accountFeaturesClass,
  'copy-container': copyContainerClass,
  'features-container': featuresContainer,
  feature: featureClass
} = styles;

const AccountFeatures = () => {
  const features = [
    {
      imgUrl: allDayAccess,
      title: '24/7 access',
      infoCopy: 'Return to your plan to make updates or purchase any time.'
    },
    {
      imgUrl: instantSharing,
      title: 'Instant sharing',
      infoCopy: 'Invite loved ones to review your plan or print for easy sharing.'
    },
    {
      imgUrl: keepPlanning,
      title: 'Keep planning',
      infoCopy: 'Use our digital planning tools to capture more of your wishes. '
    }
  ];

  return (
    <div className={accountFeaturesClass}>
      <div className={featuresContainer}>
        {features.map(({ imgUrl, title, infoCopy }) => {
          return (
            <div key={`${title}_${infoCopy}`} className={featureClass}>
              <img src={imgUrl} alt="" />
              <div className={copyContainerClass}>
                <h4>{title}</h4>
                <p>{infoCopy}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AccountFeatures;
